import { SectionTitle } from '@/components/ReportSectionHeader';
import { useSummary } from '@/hooks/useCompany';
import { useVisibleSectionsIsPristine } from '../VisibleSectionsContextProvider';

interface Props {
  title: string;
  pristineTitle?: string;
}

const CompanySectionTitle = ({ title, pristineTitle }: Props) => {
  const isPristine = useVisibleSectionsIsPristine();
  const summary = useSummary();
  const useFormattedTitle = summary.status === 'success' && isPristine;

  let formattedTitle = useFormattedTitle ? `${summary.name} ${title}` : title;
  if (typeof pristineTitle === 'string' && pristineTitle !== '') {
    /** override formattedTitle with `pristineTitle` prop */
    formattedTitle = pristineTitle;
  }
  return (
    <>
      <SectionTitle as={isPristine ? 'h1' : 'h2'}>
        {formattedTitle}
      </SectionTitle>
    </>
  );
};
export default CompanySectionTitle;
